module.exports = __webpack_public_path__ + "static/media/explosion1.2f1ab236.ogg";